module.exports = __webpack_public_path__ + "img/ca245b6.png";